import Vue from "vue";
import Vuex from "vuex";
import { TokenService } from "../services/storage.service";
import { UserService } from "../services/user.service";
import ApiService from "../services/api.service";
import router from "../router/index";
import Swal from "sweetalert2";
import ErrorService from "@/services/error.service";

Vue.use(Vuex);
export const store = new Vuex.Store({
  state: {
    accessToken: TokenService.getToken() || null,
    state_true: "Joes",
    status: "",
    authenticationError: "",
    authenticationErrorCode: false,
    authenticating: false,
    userInstance: JSON.parse(TokenService.getUser()) || {},
    adminInstance: JSON.parse(TokenService.getAdminProfile()) || {},
    permissions: TokenService.getPermissions() || null,
    userLoader: false,
    userUpdatePrompt: false,
    loading: false,
    otpLoading: false,
    changePasswordToken: "",
    allStaffs: null,
    creatingNewOrderLoading: false,
    brandName: "",
    reportsLoading: false,
    expiredTokenTime: TokenService.getExpiredTokenTime() || null,
    showOtp: false
  },
  getters: {
    //computed
    permissions: state => state.permissions,
    expiredTime: state => state.expiredTokenTime,
    loggedIn: state => {
      return state.accessToken ? true : false;
    },
    authenticating: state => {
      return state.authenticating;
    },
    authenticationError: state => {
      return state.authenticationError;
    },
    userObj: state => {
      return state.userInstance;
    },
    adminObject: state => {
      return state.adminInstance;
    },
    businessObject: state => {
      return state.businessProfile;
    },
    userLoader: state => {
      return state.userLoader;
    },
    loading: state => {
      return state.loading;
    },
    otpLoading: state => {
      return state.otpLoading;
    },
    showOtp: state => {
      return state.showOtp;
    },
    creatingNewOrderLoading: state => {
      return state.creatingNewOrderLoading;
    },
    brandName: state => {
      return state.brandName;
    },
    reportsLoading: state => {
      return state.reportsLoading;
    }
  },
  actions: {
    //methods
    loginUser: async (context, params) => {
      //commit user state
      context.commit("setLoading", true);
      context.commit("loginRequest");
      context.commit("clearError");
      try {
        const loginUser = await UserService.login(
          params.email,
          params.password,
          params.device_token
        );
        // console.log(loginUser);
        context.commit("setLoading", false);
        if (loginUser.status === 200) {
          return loginUser;
        }
      } catch (err) {
        context.commit("setLoading", false);

        let error = err.response.data;
        // console.log(error);
        ErrorService.displayErrorAlert(error);
        // context.commit("loginError", errorBag);
        throw error;
      }
    },
    verifyOtp: async (context, params) => {
      context.commit("setOtpLoading", true);
      try {
        const requestData = await UserService.verifyOtp(
          params.otp,
          params.phone_number,
          params.expoxifier,
          params.device_token
        );
        // console.log(requestData);
        context.commit("setPermissions", requestData.data.data.permissions);
        context.commit("setOtpLoading", false);
        context.commit("setAccessToken", requestData.data.data.access_token);
        context.commit("setUser", requestData.data.data.user);
        context.commit("setAdmin", requestData.data.data);
        // token expires after 10 hours
        let tokenSavedTime = Date.now() + 36000000;
        // console.log(tokenSavedTime);
        context.commit("saveTokenTime", tokenSavedTime);
        context.commit("saveDeviceToken", params.device_token);
        ApiService.setHeader();

        const mustChangePassword =
          requestData.data.data.user &&
          requestData.data.data.user.must_change_password;
        await router
          .push(mustChangePassword ? "/profile" : "/dashboard")
          .catch(error => {});
        context.commit("setOtpStatus", false);

        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          }
        });

        Toast.fire({
          icon: "success",
          title: "Signed in successfully"
        });
        console.log(requestData);
      } catch (err) {
        let error = err.response.data;
        ErrorService.displayErrorAlert(error);
        context.commit("setOtpLoading", false);
      }
    },
    registerUser: async (context, params) => {
      //commit user state
      context.commit("setLoading", true);
      context.commit("registerRequest");
      context.commit("clearError");
      try {
        const requestData = await UserService.register(
          params.first_name,
          params.last_name,
          params.email,
          params.phone_number,
          params.password
        );
        // console.log(requestData)
        context.commit("setLoading", false);
        if (requestData.account_type === "admin") {
          context.commit("setUser", requestData);
          context.commit("setAdmin", requestData.admin);
        } else {
          context.commit("setUser", requestData);
          context.commit(
            "setBusinessProfile",
            requestData.business.business_profile
          );
        }
        router.push("/verify-otp").catch(error => {});
      } catch (err) {
        let error = err.response.data;
        let errorBag = {
          code: error.response_code,
          message: error.response_message,
          data: error.data
        };
        Swal.fire({
          title: "Error!",
          text: error.data,
          icon: "error",
          confirmButtonText: "Close"
        });
        context.commit("setLoading", false);
        context.commit("registerError", errorBag);
        throw errorBag;
      }
    },
    logoutUser: async context => {
      try {
        const log = UserService.logout();
        context.commit("logoutRequest");
        await router.push("/").catch(error => {});
      } catch (err) {
        // console.log(error);
        let error = err.response.data;
        let errorBag = {
          code: error.response_code,
          message: error.response_message,
          data: error.data
        };
        throw errorBag;
      }
    },
    getUser: async context => {
      if (context.state.accessToken) {
        try {
          const user = await UserService.getUser();
          if (user.account_type === "admin") {
            context.commit("setUser", user);
            context.commit("setAdmin", user.admin);
          } else {
            context.commit("setUser", requestData);
            context.commit(
              "setBusinessProfile",
              user.business.business_profile
            );
          }
        } catch (err) {
          // console.log(error);
          let error = err.response.data;
          let errorBag = {
            code: error.response_code,
            message: error.response_message,
            data: error.data
          };
          throw errorBag;
        }
      }
    },
    updateUser: async (context, payload) => {
      context.state.userUpdatePrompt = false;
      context.commit("logUserUpdate", true);
      try {
        // context.commit('logUserUpdate')
        const updateUser = UserService.updateUser(payload);
        updateUser.then(res => {
          // console.log(res);
          context.state.userUpdatePrompt = true;
          context.commit("logUser", res.data);
          context.commit("logUserUpdate", false);
        });
      } catch (error) {
        // context.commit('logUserUpdate')
      }
    }
  },
  mutations: {
    setPermissions(state, payload) {
      state.permissions = payload;
      TokenService.savePermissions(payload);
    },
    //methods
    saveTokenTime(state, payload) {
      console.log("saved");
      state.expiredTokenTime = payload;
      TokenService.saveExpiredTokenTime(payload);
      //   state.expiredTokenTime = localStorage.setItem(
      //     "expired_token_time",
      //     payload
      //   );
    },
    loginRequest(state) {
      state.authenticating = true;
      state.authenticationError = "";
      state.authenticationErrorCode = 0;
    },
    loginSuccess: state => {
      state.authenticating = false;
    },
    loginError(state, errorBag) {
      state.authenticating = false;
      state.authenticationErrorCode = true;
      state.authenticationError = errorBag;
    },
    logUserUpdate(state, value) {
      state.userLoader = value;
    },
    logoutRequest(state) {
      state.userInstance = null;
      state.accessToken = null;
      state.adminInstance = null;
      state.permissions = null;
      TokenService.removePermissions();
    },
    registerRequest(state) {
      state.status = "loading";
    },
    registerError(state, errorBag) {
      state.authenticating = false;
      state.authenticationErrorCode = true;
      state.authenticationError = errorBag;
    },
    setAccessToken(state, accessToken) {
      TokenService.saveToken(accessToken);
      state.accessToken = accessToken;
    },
    setUser(state, user) {
      TokenService.saveUser(JSON.stringify(user));
      state.userInstance = user;
    },
    setAdmin(state, payload) {
      TokenService.saveAdminProfile(JSON.stringify(payload));
      state.adminInstance = payload;
    },
    saveDeviceToken(state, payload) {
      TokenService.saveDeviceToken(payload);
      state.deviceToken = payload;
    },
    // setBusinessProfile(state, payload) {
    //   TokenService.saveBusinessProfile(JSON.stringify(payload));
    //   state.businessProfile = payload;
    // },
    setChangePasswordToken(state, payload) {
      state.changePasswordToken = payload;
    },
    clearError(state) {
      state.authenticationError = null;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setOtpLoading(state, payload) {
      state.otpLoading = payload;
    },
    setOtpStatus(state, payload) {
      state.showOtp = payload;
    },

    setCreatingNewOrderLoading(state, payload) {
      state.creatingNewOrderLoading = payload;
    },
    setBrandName(state, payload) {
      state.brandName = payload;
    },
    setReportsLoading(state, payload) {
      state.reportsLoading = payload;
    }
  }
});
